/**
 * Retrieves a translated key from a dictionary on the window object
 * Example: ${i18n('CustomElement.buttonLabel', 'Add to cart')}
 * @param key to be translated
 * @param fallback to be used if key is not defined
 * @return String of the translated key or fallback or original key
 */
export function i18n(key, fallback) {
    const translations = window.shopI18n();

    const value = translations && translations[key];

    if (value) return value;
    else if (fallback) return fallback;
    else return key;
}
